export const SET_ECAMPAIGN = 'EMAIL/SET_ECAMPAIGN'
export const SET_ECAMPAIGNS = 'EMAIL/SET_ECAMPAIGNS'
export const SET_ECONTACTS = 'EMAIL/SET_ECONTACTS'
